import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import ExternalLink from '../../../common/external-link'

export const Container = styled.div(
    ({ theme }) => css`
        cursor: pointer;
        border-radius: ${theme.typography.border.radius.small};
        text-decoration: none;
        margin: 0;

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin: 0 1.5rem 0 0;
        }

        & :last-child {
            margin-right: 0;
        }
    `,
)

export const InnerContainer = styled.div(
    ({ theme }) => css`
        display: ${theme.style.display.flex};
        flex-direction: column;
        background-color: ${theme.colors.white};
        position: ${theme.style.position.relative};
        transition: box-shadow 200ms ease-out;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin: 0;
            flex-direction: ${theme.style.flexDirection.column};
            max-width: 18.75rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin: 0;
            max-width: 20rem;
        }
    `,
)

export const ImageContainer = styled.div``

export const NextImageContainer = styled.div`
    overflow: hidden;
    border-radius: 1rem;

    img {
        width: 100%;
        height: auto;
        display: block;
    }
`

export const FooterContainer = styled.div(
    ({ theme }) => css`
        display: ${theme.style.display.flex};
        flex-direction: ${theme.style.flexDirection.column};
        padding: 1rem 0 0;
    `,
)

export const AccommodationContainer = styled.h4(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 400;
        font-size: 0.75rem;
        line-height: 1.25rem;
        color: #5f5f5f;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 0.875rem;
        }
    `,
)

export const RegionTitleContainer = styled.h3(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 1.5;
        color: #282828;
        width: 8rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 1rem;
            line-height: 1.5rem;
            width: 10.68rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: 8.88rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            width: 11.25rem;
        }
    `,
)

export const SeoHref = styled(ExternalLink)`
    font: inherit;
    text-decoration: none;
`
